import { useState } from "react";
import { Check, Copy } from "lucide-react";

interface Props {
  value: string;
  label?: string;
  className?: string;
  size?: number;
}

export function CopyButton({ value, label, className = "", size = 14 }: Props) {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // Fallback: select + execCommand (best effort)
      const el = document.createElement("textarea");
      el.value = value;
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
      } catch {
        /* ignore */
      } finally {
        document.body.removeChild(el);
      }
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`group inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-ink-400 hover:text-phosphor-300 transition-colors ${className}`}
      aria-label={label ? `Copy ${label}` : "Copy"}
    >
      {copied ? (
        <>
          <Check size={size} className="text-signal-400" />
          <span className="text-signal-400">copied</span>
        </>
      ) : (
        <>
          <Copy size={size} className="group-hover:text-phosphor-300" />
          <span>{label ?? "copy"}</span>
        </>
      )}
    </button>
  );
}
